<template>
<div>
    <!-- loading -->
    <img v-if="checkCached(imageUrl)" class="absolute thumbnail-template" alt="Grafias" :src="imageUrl">
    <clazy-load v-if="!checkCached(imageUrl)" class="absolute thumbnail-template" alt="Grafias" :src="imageUrl">
        <!-- The image slot renders after the image loads. -->
        <img class="absolute thumbnail-template" alt="Grafias" :src="imageUrl">
        <!-- The placeholder slot displays while the image is loading. -->
        <div slot="placeholder">
				<img class="absolute thumbnail-gallery" :src="'/img/Rolling-1s-90px.svg'">
        </div>
    </clazy-load>
</div>
</template>

<script>
import localforage from 'localforage';

export default {

	name: 'GalleryPopupImageThumbnail',
	props: {
		template: {
			type: Object,
		},
	},
	components: {
		// SkeletonLoader,
		// ContentLoader,
	},
	data() {
		return {
			source: '',
		};
	},
	created() {
		this.asyncgetSource();
	},
	methods: {
		asyncgetSource() {
			const itemKey = `thumbnail_template_${this.template.id}`;
			this.source = this.template && this.template.img_path ? this.template.img_path : '/img/TemplateThumbnailDefault_01.jpg';
			localforage.getItem(itemKey).then((value) => {
				if (value) {
					this.source = URL.createObjectURL(value);
					return (this.source);
				}
				return (this.source);
			});
		},
		checkCached(imgUrl) {
			const thumbnail = this.template && this.template.img_path ? this.template.img_path : '/img/TemplateThumbnailDefault_01.jpg';
			if (imgUrl === thumbnail) return false;
			return true;
		},
	},
	computed: {
		imageUrl() {
			return (this.source);
		},
	},
	watch: {
		async template() {
			this.asyncgetSource();
		},
	},
};
</script>
